import { render, staticRenderFns } from "./ProblemFeedback.vue?vue&type=template&id=3ab843c0"
import script from "./ProblemFeedback.vue?vue&type=script&lang=js"
export * from "./ProblemFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports